import { Chip } from "@mui/material";

export default function RequiredChip() {
  return (
    <Chip
      label='Required'
      size='small'
      color='primary'
      variant='outlined'
      sx={{ ml: 1, fontSize: "0.7rem", height: 20 }}
    />
  );
}
